export class FindDiffusionList {
    nameList: string;
}
